import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showSuccess, showConfirmation } from '../../services/alert';

const InsumoList = () => {
  const [insumos, setInsumos] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchInsumos = async () => {
    setLoading(true);
    try {
      const res = await api.get('/insumos');
      setInsumos(res.data);
    } catch (err) {
      console.error('Erro ao buscar insumos:', err);
      showError('Erro ao buscar insumos.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInsumos();
  }, []);

  const handleDelete = async (id) => {
    const confirmou = await showConfirmation({
      title: 'Excluir insumo?',
      text: 'Essa ação não pode ser desfeita.',
      confirmText: 'Sim, excluir',
      cancelText: 'Cancelar',
    });
    if (!confirmou) return;

    try {
      await api.delete(`/insumos/${id}`);
      showSuccess('Insumo excluído com sucesso.');
      fetchInsumos();
    } catch (err) {
      console.error('Erro ao excluir insumo:', err);
      showError('Erro ao excluir insumo.');
    }
  };

  const columns = [
    { name: 'Nome', selector: row => row.nome, sortable: true },
    { name: 'Tipo', selector: row => row.tipo, sortable: true },
    { name: 'Unidade', selector: row => row.unidadeMedida, sortable: true },
    { name: 'Estoque Atual', selector: row => Number(row.estoqueAtual || 0).toLocaleString('pt-BR'), sortable: true },
    { name: 'Estoque Mínimo', selector: row => Number(row.estoqueMinimo || 0).toLocaleString('pt-BR'), sortable: true },
    { name: 'Custo Médio', selector: row => Number(row.valorMedio || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), sortable: true },
    { name: 'Fornecedor', selector: row => row.fornecedorNome || '-', sortable: true },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() => navigate(`/insumos/editar/${row.id}`)}
          >
            <i className="bi bi-pencil-square"></i> Editar
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i> Excluir
          </button>
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/menu')}
              disabled={loading}
            >
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Insumos</h5>
              <small className="text-white-50">Gerencie insumos e estoque</small>
            </div>
          </div>
          <button
            className="btn btn-light text-success fw-bold"
            onClick={() => navigate('/insumos/create')}
          >
            <i className="bi bi-plus-circle"></i> Novo Insumo
          </button>
        </div>
        <div className="card-body">
          <DataTable
            columns={columns}
            data={insumos}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={<div className="text-muted">Nenhum insumo encontrado.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default InsumoList;
